/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../../layout/content/Content";
import { Spinner } from "reactstrap"
import { Doughnut } from "react-chartjs-2";
import {
    Block,
    BlockDes,
    BlockHead,
    Col,
    Row,
    PreviewAltCard,
} from "../../../../../components/Component";
import Head from "../../../../../layout/head/Head";
import DGEDashboardCountCP from "./DGEDashboardCountCP";
import ButtonDisableCP from "./ButtonDisableCP";
import SingleQuater from "../../../../components/DynmicOption/singlequarter";
import FinancialYear from "../../../../components/DynmicOption/FinancialYear";

const CPDGEDashboard = () => {
    const [activedata, setactivedata] = useState([])
    const [lorder, setLorder] = useState(true);
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [selectedYear, setSelectedYear] = useState("")
    const [Selected, setSelected] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])

    const [data2, setData2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [12, 8, 7],
            },
        ],
    })

    const tableRef = useRef(null);

    const getdata = async () => {
        const sendData = {
            CatgId: Number(43),

        }
        /*//console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/Getstate', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => { 
                    setactivedata(data)
                    setLorder(false)
                })


    };

    const getdata2 = async () => {
 
        const sendData = {
            MonthId: Number(selectedOptions.value),
            YearId: Number(selectedYear),
        }
       //console.log("sendData", sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/DgeGraphCP', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                   console.log(data)
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setData2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    }
    
    useEffect(() => {
        if (selectedOptions.value > 0 && selectedYear > 0) {

            getdata()
            getdata2()
            setLorder(true)
        }
    }, [selectedOptions, selectedYear])
    
    return (<>

            <React.Fragment>
                <Head title="AllUser" />

                <Content>


                    <Block>

                        <BlockHead size="lg">

                            <BlockDes className="text-soft">

                                <Row>

                                    <Col xl="4" md="4">
                                          <h5 style={{ color: '#798bff' }}>CP DGE Dashboard</h5>
                                    </Col>

                                    <Col xl="4" md="4" >
                                        <label style={{ color: 'black', fontSize: 15 }}>  Year :  <label style={{ fontWeight: 'bold' }}><FinancialYear selectedYear={selectedYear} setSelectedYear={setSelectedYear}/></label></label>

                                    </Col>

                                <Col xl="4" md="4">
                                    <label style={{ color: 'black' }} >  Quarter: <label style={{ fontWeight: 'bold' }}> <SingleQuater setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} setSelected={setSelected} Selected={Selected} /></label></label>
                                    </Col>

                                </Row>
                                <hr />
                                <Row>
                                    <Col md="4" xxl="4">
                                        <PreviewAltCard border1={true} className="h-100">
                                            <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The DGE dashboard shows the data of employment exchange of a particular month

                                            </small></h6>
                                        </PreviewAltCard>
                                    </Col>
                                    <Col md="8" xxl="8">
                                        <PreviewAltCard border1={true} className="h-100">
                                            <Row>
                                                <Col md="2"></Col>
                                                <Col md="6">
                                                    <div className="traffic-channel-group">

                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                                <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>

                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                                <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}>{Edit.submit}</large></b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>
                                                        <div >
                                                            <div className="title">
                                                                <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                                <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}> {Edit.open}</large></b>
                                                            </div>
                                                            <div className="amount">

                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                                <Col md="4">
                                                    <div className="traffic-channel-doughnut-ck">
                                                        <Doughnut
                                                            className="analytics-doughnut"
                                                            data={data2}
                                                            options={{
                                                                legend: {
                                                                    display: false,
                                                                },
                                                                rotation: -1.5,
                                                                cutoutPercentage: 70,
                                                                maintainAspectRatio: false,
                                                                tooltips: {
                                                                    enabled: true,
                                                                    backgroundColor: "#fff",
                                                                    borderColor: "#eff6ff",
                                                                    borderWidth: 2,
                                                                    titleFontSize: 13,
                                                                    titleFontColor: "#6783b8",
                                                                    titleMarginBottom: 6,
                                                                    bodyFontColor: "#9eaecf",
                                                                    bodyFontSize: 12,
                                                                    bodySpacing: 4,
                                                                    yPadding: 10,
                                                                    xPadding: 10,
                                                                    footerMarginTop: 0,
                                                                    displayColors: false,
                                                                },
                                                            }}
                                                        ></Doughnut>
                                                    </div>

                                                </Col>
                                            </Row>
                                        </PreviewAltCard>

                                    </Col>
                                </Row>
                            </BlockDes>


                        </BlockHead>


                        <div className="table-responsive">
                            <table className="table table-orders" ref={tableRef}>
                                <thead className="tb-odr-head">
                                    <tr className="tb-odr-item" >

                                        <th >
                                            List

                                        </th>
                                        <th >
                                            No. of EEX

                                        </th>
                                        <th >
                                            Total Forms

                                        </th>
                                        <th >
                                            Open

                                        </th>
                                        <th >
                                            Draft

                                        </th>
                                        <th >
                                            Submited

                                        </th>
                                        <th >
                                            Action

                                        </th>



                                    </tr>


                            </thead>
                            {lorder ? null :<>
                                {activedata.length !== 0 ? activedata.map((details) =>
                                        <tr>

                                        <td> <a href="#id" onClick={() => (sessionStorage.setItem("StateCP", details.catgTypeId), window.location.pathname = "/CPStatedashboard")} ><b style={{ fontSize: 18 }}>{details.catgType}</b>
                                            </a></td>

                                        <DGEDashboardCountCP year={selectedYear} month={selectedOptions.value} catgtype={details.catgTypeId} api={'Dgecountcp'} />
                                        <ButtonDisableCP year={selectedYear} month={selectedOptions.value} catgtype={details.catgTypeId} api={'Dgecountcp'} />
                                            </tr>
                                ) : <Spinner color="success" />
                                }</>
                            }




                            </table>

                        </div>




                    </Block>




                </Content>

            </React.Fragment>
    </>
    );
};

export default CPDGEDashboard;
